<template>
    <div>
        <!-- 搜索筛选 -->
        <div style="margin-right:2%;display: flex;align-items: center;">
            <span style=" float:none; margin-right:2%;display: flex;align-items: center;">
                <h1>{{outlet}}</h1>
            </span>
            <span style=" float:none; text-align: center; margin-right:2%;display: flex;align-items: center;">
                <el-date-picker
          style='margin: 10px 0;'
            v-model="dateTime"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            >
          </el-date-picker>
          <el-button style=' margin: 10px;' size="mini" type="primary"
              icon="document" @click="dataSelect">筛选</el-button> 

            </span>
            
              <span style=" float:right; margin-right:2%;display: flex;align-items: center;">
                <span
                style="background-color: rgb(66, 185, 131); color: rgb(255, 255, 255); border-radius: 8px;display: block;padding: 8px 20px;">
                提现总额：{{ cashTotal || 0 }}
            </span>
            <span
                style="margin: 8px;background-color: rgb(66, 185, 131); color: rgb(255, 255, 255); border-radius: 8px;display: block;padding: 8px 20px;">
                手续费总额：{{ feeTotal || 0 }}
            </span>
              </span>
            
        </div>

        <el-table style="width:100%" border v-loading="tableDataLoading" :data="tableData" row-key="id"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column align="center" prop="payState" label="提现状态">
                <template slot-scope="scope">
                    <span v-if="scope.row.payState == 0">待处理</span>
                    <span v-if="scope.row.payState == 1">提现成功</span>
                    <span v-if="scope.row.payState == 2">提现失败</span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="payTime" label="提现时间">
            </el-table-column>
            <el-table-column align="center" prop="payFee" label="到账金额(元)">
            </el-table-column>
            <el-table-column align="center" prop="fee" label="手续费(元)">
            </el-table-column>
            <el-table-column align="center" prop="cashMoney" label="提现金额(元)">
            </el-table-column>
            <el-table-column align="center" prop="payType" label="提现方式">
                <template slot-scope="scope">
                    <span v-if="scope.row.payType == 0">支付宝</span>
                    <span v-if="scope.row.payType == 1">银行卡</span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="account" label="账户">
            </el-table-column>
            <el-table-column align="center" prop="realName" label="姓名">
            </el-table-column>
        </el-table>
        <div style="text-align: center;margin-top: 10px;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" :current-page="page"
                layout="total,sizes, prev, pager, next" :total="totalnum">
            </el-pagination>
        </div>

    </div>
</template>

<script>

import { getTeamPremiumList } from '../../../api/manage/team.js'

import moment from 'moment';

export default {
    data() {
        return {
            cashTotal: '',
            feeTotal: '',
            teamId: '',
            outlet: '',
            startDate: '',
            endDate: '',
            dateTime: '',
            outlet: '',
            multipleSelection: [],
            totalnum: 0,
            page: 1,
            size: 10,
            tableDataLoading: false,
            dialogFormVisible: false,
            tableData: [],

        }
    },
    components: {

    },

    created() {
        this.teamId = this.$route.query.teamId
        this.dataSelect()
        // this.getdata(1)
    },
    mounted() {
        // console.log(this.$route.query,'接收页面参数---'); // 输出从URL获得的ID

    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {

        handleSizeChange(val) {
            this.size = val;
            this.dataSelect()
        },
        handleCurrentChange(val) {
            this.page = val;
            this.dataSelect()
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        dataSelect() {
            let value=this.dateTime;
            if (Array.isArray(value) && value.length === 2) {
            this.startDate = value[0];
            this.endDate = value[1];
            } else {
            this.startDate = '';
            this.endDate = '';
            }
            let post = {
                teamId: this.teamId,
                page: (this.page - 1) * this.size,
                size: this.size,
                startDate: this.startDate,
                endDate: this.endDate
            }
            this.tableDataLoading = true
            getTeamPremiumList(post).then((res) => {
                this.tableDataLoading = false
                if (res.code == 200) {
                    this.tableData = res.data.list
                    this.cashTotal = res.data.cashTotal
                    this.feeTotal = res.data.feeTotal
                    this.totalnum = res.data.count;
                    this.outlet = res.data.outlet;
                    return;
                }
                this.$message({
                    type: "info",
                    message: res.msg,
                });
            })
        },

    }
}
</script>

<style scoped>
.userRole {
    width: 100%;

}
</style>


// WEBPACK FOOTER //
// src/views/manage/team/premiumList.vue